import Joi from "joi";
import errorsResolver from "../schemeUtils";

const accepted = {
  CREDIT: 'Принято от',
  DEBIT: 'Выдать'
}
const LENGTH = 200;
export const createTransactionScheme = (type) => {
  return Joi.object({
    section: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Основание обязательное поле`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Основание обязательное поле`,
        required: `Основание обязательное поле`
      })),
    amount: Joi.number()
      .required().empty('')
      .max(99999999.99)
      .min(0.01)
      .precision(2)
      .error(errorsResolver({
        numberUnsafe: `Сумма должна быть корректным числом`,
        numberMin: `Сумма должна быть больше нуля`,
        numberMax: `Сумма должна быть меньше 99999999.99`,
        number: `Сумма должна быть числом`,
        required: `Сумма обязательное поле`,
        numberBase: `Сумма должна быть числом`
      })),
    documentNumber: Joi.number()
      .required().empty('')
      .max(999999999)
      .min(0)
      .integer()
      .error(errorsResolver({
        numberUnsafe: `Номер документа должен быть меньше 10 символов`,
        numberMin: `Номер документа должен больше нуля`,
        numberMax: `Номер документа должен быть меньше 10 символов`,
        number: `Номер документа должен быть числом`,
        required: `Номер документа обязательное поле`,
        numberBase: `Номер документа должен быть числом`
      })),
    accepted:
      Joi.object({
        label: Joi.string()
          .required()
          .max(LENGTH)
          .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-., ]*$'))
          .error(errorsResolver({
            required: `${accepted[type]} обязательное поле`,
            pattern: `Поле содержит некорректные символы`,
            max: `Поле выдать должно содержать не более ${LENGTH} символов`
          })),
        value: Joi.number()
          .error(errorsResolver({
            number: `Должно быть число`,
          }))
      })
        .invalid(null)
        .required()
        .error(errorsResolver({
          invalid: `${accepted[type]} обязательное поле`,
          required: `${accepted[type]} обязательное поле`,
          objectBase: `${accepted[type]} обязательное поле`
        })),
    date: Joi.date()
      .required()
      .iso()
      .error(errorsResolver({
        dateFormat: `Некорректная дата`
      })),
    description: Joi.string()
      .max(LENGTH)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-.,№*()/\\\\ \n]*$'))
      .error(errorsResolver({
        max: `Приложение должно быть до 200 символов`,
        pattern: `Приложение содержит некорректные символы`
      })),
    attachment: Joi.string()
      .max(LENGTH)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-.,№:()/\\\\ ]*$'))
      .error(errorsResolver({
        max: `Дополнительная информация должна быть до 200 символов`,
        pattern: `Дополнительная информация содержит некорректные символы`
      })),
    passport: Joi.string()
      .max(LENGTH)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\-.,;0-9 ()]*$'))
      .error(errorsResolver({
        max: `Паспортные данные должны быть до 200 символов`,
        pattern: `Паспортные данные содержит некорректные символы`
      })),
    payment: Joi.string()
      .required()
      .error(errorsResolver({
        required: `Выберите наличный или безналичный расчёт`,
      })),
    toPerson: Joi.bool()
  });
}

export const transactionRecalculationScheme = () => createTransactionScheme(accepted.DEBIT).keys({
  passport: Joi.string()
    .max(LENGTH)
    .trim()
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\-.,;0-9 ()}]*$`))
    .error(errorsResolver({
      max: `Паспортные данные должны быть до 200 символов`,
      pattern: `Паспортные данные содержит некорректные символы`,
      required: 'Паспортные данные обязательное поле'
    })),
})


export const createTransactionBatchScheme = (type) => {
  return Joi.object({
    section: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Основание обязательное поле`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        })),
      isDisabled: Joi.bool(),
      isDefaultPayment: Joi.bool()
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Основание обязательное поле`,
        required: `Основание обязательное поле`
      })),
    date: Joi.date()
      .required()
      .iso()
      .error(errorsResolver({
        dateFormat: `Некорректная дата`
      })),
    documentNumber: Joi.number()
      .required().empty('')
      .max(999999999)
      .min(0)
      .integer()
      .error(errorsResolver({
        numberUnsafe: `Номер документа должен быть меньше 10 символов`,
        numberMin: `Номер документа должен больше нуля`,
        numberMax: `Номер документа должен быть меньше 10 символов`,
        number: `Номер документа должен быть числом`,
        required: `Номер документа обязательное поле`,
        numberBase: `Номер документа должен быть числом`
      })),
    accepted: Joi.object({
      label: Joi.string()
        .required()
        .max(LENGTH)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-., ]*$'))
        .error(errorsResolver({
          required: `${accepted[type]} обязательное поле`,
          pattern: `Поле содержит некорректные символы`,
          max: `Поле выдать должно содержать не более ${LENGTH} символов`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `${accepted[type]} обязательное поле`,
        required: `${accepted[type]} обязательное поле`,
        objectBase: `${accepted[type]} обязательное поле`
      })),
    description: Joi.string()
      .max(LENGTH)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-/.,№ \n ]*$'))
      .error(errorsResolver({
        max: `Приложение должно быть до 200 символов`,
        required: `Приложение обязательное поле`,
        pattern: `Приложение содержит некорректные символы`
      })),
    passport: Joi.string()
      .max(LENGTH)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\-.,;0-9 ]*$'))
      .error(errorsResolver({
        max: `Паспортные данные должны быть до 200 символов`,
        required: `Паспортные данные обязательное поле`,
        pattern: `Паспортные данные содержит некорректные символы`
      })),
    toPerson: Joi.bool(),
    cashType: Joi.string(),
  });
}
